<template>
    <table v-if="group" class="detail-table">
      <tbody>
        <tr>
          <th>Tutor ID</th>
          <td>{{ group.tutor.id }}</td>
        </tr>
        <tr>
          <th>Tutor name</th>
          <td>{{ group.tutor.name }}</td>
        </tr>
        <tr>
          <th>Level</th>
          <td>{{ group.level.name }}</td>
        </tr>
        <tr>
          <th>day of week</th>
          <td>{{ group.dayOfWeek | weekday }}</td>
        </tr>
        <tr>
          <th>Period</th>
          <td>{{ group.period }}</td>
        </tr>
        <tr>
          <th>University</th>
          <td>{{ group.university.name }}</td>
        </tr>
        <tr>
          <th>Campus</th>
          <td>{{ group.campus.name }}</td>
        </tr>
        <tr>
          <th>Booth</th>
          <td>{{ group.booth | booth }}</td>
        </tr>
      </tbody>
    </table>
</template>

<script lang="ts">
import {
  Component, Prop, Vue,
} from 'vue-property-decorator'
import { Group } from '@/store/groups/types'
import { Booth } from '@/store/booths/types'
import { weekdayKey, Weekdays } from '@/store/common.types'

@Component({
  filters: {
    weekday: (w: weekdayKey) => Weekdays[w],
    booth: (b: Booth): string => `${b?.building} - ${b?.room} - ${b?.number}`,
  },
})
export default class GroupView extends Vue {
  @Prop() value!: Group

  private get group(): Group {
    return this.value
  }
}
</script>

<style scoped>
table.detail-table {
  width:100%;
}

table.detail-table th {
  display: block;
  text-align: left;
  margin:10px 0;
}

table.detail-table td {
  display: block;
  margin:10px 0;
}
</style>
